import { render, staticRenderFns } from "./SubmitHistoryDialog.vue?vue&type=template&id=b3fd66b8&scoped=true&"
import script from "./SubmitHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubmitHistoryDialog.vue?vue&type=style&index=0&id=b3fd66b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd66b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDialog,VDivider,VIcon,VSimpleTable,VSpacer})
